import React from "react";
import ShoppingCart from "../components/ShoppingCart";

const Shopping = ({ current_user }) => {
  return <ShoppingCart current_user={current_user}></ShoppingCart>;
};

export default Shopping;
